// styles
import styled from 'styled-components';
import { ChevronBottomIcon, ChevronTopIcon } from 'refactored/ui/icons';
import { useTranslation } from 'react-i18next';

const TogglePriceBreakdownText = styled.div`
  /* 12px/medium */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  /* secondary / white */

  color: var(--white);

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
  cursor: pointer;
`;

const SoFormCandidateBlockDetailsTogglePriceBreakdown = ({
  showPriceBreakdown,
  className,
  ...props
}) => {
  const { t } = useTranslation('Catalog');

  return (
    <div className={className} {...props}>
      <TogglePriceBreakdownText>
        {showPriceBreakdown
          ? t('price.hide_price_breakdown')
          : t('price.show_price_breakdown')}
      </TogglePriceBreakdownText>

      {showPriceBreakdown ? <ChevronTopIcon /> : <ChevronBottomIcon />}
    </div>
  );
};

export default styled(SoFormCandidateBlockDetailsTogglePriceBreakdown)`
  /* Frame 167 */

  /* Auto layout */

  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 2px 16px 2px 0px;
  gap: 8px;

  width: 600px;
  height: 20px;

  background: var(--primary300);

  /* Inside auto layout */

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  svg {
    path {
      fill: var(--white);
    }
  }
`;
